import { PropsWithChildren, RefCallback, useCallback, useState } from "react";

import Box from "@mui/material/Box";

import { DashboardTooltipProps } from "@/dashboard-design-system/Tooltip";
import { DashboardTooltip } from "@/dashboard-design-system/Tooltip/DashboardTooltip";

interface TruncatedTextWithTooltipProps {
  tooltipProps: Pick<DashboardTooltipProps, "title" | "placement" | "data-test">;
  "data-test"?: string;
}

export const TruncatedTextWithTooltip = ({
  children,
  tooltipProps,
  "data-test": dataTest,
}: PropsWithChildren<TruncatedTextWithTooltipProps>) => {
  const { title, ...restTooltipProps } = tooltipProps;
  const [spanElement, setSpanElement] = useState<HTMLSpanElement | null>(null);
  const refCallback = useCallback<RefCallback<HTMLDivElement>>((ref) => setSpanElement(ref), []);
  const showTooltip: boolean = spanElement ? spanElement?.offsetWidth < spanElement?.scrollWidth : false;
  return (
    <DashboardTooltip title={showTooltip ? title : ""} {...restTooltipProps}>
      <Box
        component="span"
        ref={refCallback}
        data-test={dataTest}
        sx={(theme) => ({
          ...theme.mixins.truncateOverflow,
          display: "block",
        })}
      >
        {children}
      </Box>
    </DashboardTooltip>
  );
};
